import {
    getSystemList,
    getVendorList,
    getCountryList,
    getUnitList,
    getVendorStatusList,
    getStockTypeList,
    getVendorType,
    getBusinessRegionList
  } from '@/views/buyershop/api';
export default {
    namespaced: true,
    state:{
        systemList:[],
        vendorList:[],
        countryList:[],
        unitList:[],
        vendorStatusList:[],
        stockTypeList:[],
        vendorTypeList:[],
        businessRegionList:[] //业务区域列表
    },
    actions:{
        getSystemList({commit}){ //获取系统名称列表
            getSystemList().then(res=>{
              let systemList = res&&res.data&&(res.data.data || []).map(item=>{
                return {
                  value:item.vendorSystemId,
                  label:item.systemName
                }
              })
               commit('getSystemList',systemList);
            })
        },
        getVendorList({commit}){ //获取所有店铺枚举
            getVendorList().then(res=>{
              let vendorList = res&&res.data&&(res.data.data || []).map(item=>{
                return {
                  value:item.vendorId,
                  label:item.vendorName
                }
              })
              commit('getVendorList',vendorList);
            })
        },
        getCountryList({commit}){ //所有国家列表
          getCountryList().then(res=>{
            let countryList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.addressCountryId,
                label:item.name
              }
            })
            commit('getCountryList',countryList);
          })
        },
        getUnitList({commit}){ //所有货币单位枚举
          getUnitList().then(res=>{
            let unitList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.fromCountry,
                label:item.fromCountry
              }
            })
            commit('getUnitList',unitList);
          })
        },
        getVendorStatusList({commit}){ //获取店铺状态
          getVendorStatusList().then(res=>{
            let vendorStatusList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.value,
                label:item.desc,
                code:item.code
              }
            })
            commit('getVendorStatusList',vendorStatusList);
          })
        },
        getStockTypeList({commit}){ //所有库存枚举列表
          getStockTypeList().then(res=>{
            let stockTypeList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.value,
                label:item.desc,
                code:item.code
              }
            })
            commit('getStockTypeList',stockTypeList);
          })
        },
        getVendorType({commit}){ //所有库存枚举列表
          getVendorType().then(res=>{
            let vendorTypeList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.value,
                label:item.desc,
                code:item.code
              }
            })
            commit('getVendorType',vendorTypeList);
          })
        },
        getBusinessRegionList({commit}){ //所有业务区域列表
          getBusinessRegionList().then(res=>{
            let businessRegionList = res&&res.data&&(res.data.data || []).map(item=>{
              return {
                value:item.businessRegionId,
                label:item.businessRegionName,
              }
            })
            commit('getBusinessRegion',businessRegionList);
          })
        },
        
        

    },
    mutations:{
      getSystemList(store,systemList){
          store.systemList = systemList
      },
      getVendorList(store,vendorList){
          store.vendorList = vendorList
      },
      getCountryList(store,countryList){
          store.countryList = countryList
      },
      getUnitList(store,unitList){
          store.unitList = unitList
      },
      getVendorStatusList(store,unitList){
          store.vendorStatusList = unitList
      },
      getStockTypeList(store,stockTypeList){
          store.stockTypeList = stockTypeList
      },
      getVendorType(store,vendorTypeList){
          store.vendorTypeList = vendorTypeList
      },
      getBusinessRegion(store,businessRegionList){
          store.businessRegionList = businessRegionList
      },
      
    },
    getters:{
      systemList: s => s.systemList,
      vendorList: s => s.vendorList,
      countryList: s => s.countryList,
      unitList: s => s.unitList,
      vendorStatusList: s => s.vendorStatusList,
      stockTypeList: s => s.stockTypeList,
      vendorTypeList: s => s.vendorTypeList,
      businessRegionList: s => s.businessRegionList
    }

}
